function clearCurrencyValue(value) {
  var safeValue = value || "";
  var withoutDot = safeValue.replace(".", "");
  var withReplacedComma = withoutDot.replace(",", ".");
  var onlyNumbers = withReplacedComma.replace(/[^0-9\.-]+/g, "");
  return Number(onlyNumbers);
}
export { clearCurrencyValue as default };